export enum BreakpointEnum {
  XL = 'xl',
  MD = 'md',
  SM = 'sm',
  XS = 'xs',
}
